import { isNil } from 'lodash-es';
import type React from 'react';
import { useEffect, useState } from 'react';
import { ROUTES } from '../../constants/Constants';
import useAppNavigation from '../../hooks/useAppNavigation';
import useUser from '../../hooks/useUser';

type Props = {
  children: React.ReactNode;
};

const PartnerRoute = ({ children }: Props) => {
  const [initialized, setInitialized] = useState<boolean>(false);
  const { isLoggedIn, isPartner, currentUser } = useUser();
  const { navigate, toLocalizedRoute } = useAppNavigation();
  const [descent, setDescent] = useState<React.ReactNode | null>(null);

  useEffect(() => {
    if (initialized) {
      if (isLoggedIn) {
        if (!isNil(currentUser)) {
          if (!isPartner) {
            console.log('User. You shall not pass! 🧙');
            navigate(toLocalizedRoute(ROUTES.HOME_ROUTE), { replace: true });
          } else {
            setDescent(children);
          }
        }
      } else {
        console.log('Guest. You shall not pass! 🧙');
        navigate(toLocalizedRoute(ROUTES.HOME_ROUTE), { replace: true });
      }
    }
  }, [
    isLoggedIn,
    currentUser,
    isPartner,
    children,
    navigate,
    initialized,
    toLocalizedRoute,
  ]);

  useEffect(() => {
    setInitialized(true);

    return () => {
      setInitialized(false);
    };
  }, []);

  return descent;
};

export default PartnerRoute;
